enum Role {
    /**
     * Primary role value
     */
    Primary,

    /**
     * Secondary role value
     */
    Secondary,
}

export default Role;
